export const FETCH_STATUS = {
  NOT_STARTED: "N",
  REQUESTED: "R",
  SUCCEEDED: "S",
  FAILED: "F"
};



// WEBPACK FOOTER //
// ./src/constants.js